import { render, staticRenderFns } from "./SickLeaveTypeSelector.vue?vue&type=template&id=81580ee0"
import script from "./SickLeaveTypeSelector.vue?vue&type=script&lang=js"
export * from "./SickLeaveTypeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports